function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOhifLogo = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 150,
  height: 70,
  style: {
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  },
  viewBox: "0 0 2666.66 2000",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 456.75,
  x2: 467.74,
  y1: 563.45,
  y2: 1444.77,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopOpacity: 1,
    stopColor: "#24a0a4"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.322,
  style: {
    stopOpacity: 1,
    stopColor: "#0983d7"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopOpacity: 1,
    stopColor: "#4bc95a"
  }
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 1333.44,
  x2: 1333.44,
  y1: 729.35,
  y2: 1186.67,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopOpacity: 1,
    stopColor: "#24a0a4"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  style: {
    stopOpacity: 1,
    stopColor: "#0983d7"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopOpacity: 0.709804,
    stopColor: "#4bc95a"
  }
}))), /*#__PURE__*/React.createElement("path", {
  d: "m1112.56 1097.84-.27-126.17-62.54 104.41h-15.77L971.44 973.3v124.54h-33.72V907.51h29.09l75.59 126.17 74.23-126.17h29.09l.28 190.33zm218.07-71.78c0 2.36-.18 5.71-.54 10.06h-113.93c1.99 10.7 7.2 19.17 15.63 25.43 8.43 6.25 18.9 9.38 31.41 9.38 15.95 0 29.09-5.26 39.43-15.77l18.22 20.94c-6.53 7.8-14.78 13.69-24.74 17.67-9.97 3.99-21.21 5.98-33.72 5.98-15.95 0-30-3.17-42.15-9.52-12.14-6.35-21.52-15.19-28.14-26.51-6.61-11.33-9.92-24.16-9.92-38.48 0-14.14 3.22-26.87 9.65-38.2 6.44-11.33 15.36-20.17 26.78-26.51 11.42-6.35 24.29-9.52 38.61-9.52 14.14 0 26.78 3.13 37.93 9.38s19.85 15.05 26.1 26.37c6.26 11.33 9.38 24.43 9.38 39.29zm-73.41-47.85c-10.88 0-20.08 3.22-27.6 9.65-7.52 6.44-12.1 15-13.73 25.7h82.39c-1.45-10.52-5.89-19.03-13.32-25.56s-16.68-9.79-27.73-9.79zm248.25-70.7v190.33h-32.63v-18.76c-5.62 6.89-12.55 12.05-20.8 15.5-8.25 3.44-17.36 5.17-27.33 5.17-13.96 0-26.51-3.08-37.66-9.24-11.15-6.17-19.9-14.91-26.24-26.24s-9.52-24.33-9.52-39.02c0-14.68 3.17-27.65 9.52-38.88 6.34-11.24 15.09-19.94 26.24-26.11 11.15-6.16 23.7-9.24 37.66-9.24 9.61 0 18.4 1.63 26.38 4.89s14.78 8.16 20.39 14.68v-63.08zm-76.68 163.15c8.16 0 15.5-1.86 22.03-5.57 6.52-3.72 11.69-9.02 15.5-15.91s5.71-14.86 5.71-23.93-1.91-17.04-5.71-23.93-8.97-12.19-15.5-15.91-13.87-5.57-22.03-5.57-15.5 1.86-22.02 5.57-11.69 9.02-15.5 15.91c-3.8 6.89-5.71 14.86-5.71 23.93 0 9.06 1.91 17.04 5.71 23.93 3.81 6.89 8.98 12.19 15.5 15.91 6.53 3.72 13.87 5.57 22.02 5.57m121.27-118.01h33.99v145.2h-33.99zm256.69 145.2-.27-126.17-62.54 104.41h-15.77l-62.54-102.78v124.54h-33.72V907.52H1661l75.59 126.17 74.23-126.17h29.09l.28 190.33zm137.04-146.83q32.085 0 49.08 15.36c11.33 10.24 17 25.7 17 46.36v85.11h-32.09v-17.67c-4.17 6.34-10.11 11.19-17.81 14.55-7.7 3.35-16.99 5.03-27.87 5.03s-20.39-1.86-28.55-5.57c-8.16-3.72-14.46-8.88-18.9-15.5-4.44-6.61-6.66-14.09-6.66-22.43 0-13.06 4.85-23.52 14.55-31.41s24.97-11.83 45.82-11.83h37.52v-2.18c0-10.15-3.04-17.94-9.11-23.38q-9.105-8.16-27.06-8.16c-8.16 0-16.18 1.27-24.07 3.81-7.88 2.54-14.54 6.07-19.98 10.6l-13.32-24.74c7.61-5.8 16.77-10.24 27.46-13.32q16.05-4.62 33.99-4.62zm-4.63 123.99q12.78 0 22.71-5.85c6.61-3.9 11.28-9.47 14-16.72v-16.86h-35.08c-19.58 0-29.37 6.44-29.37 19.31 0 6.17 2.45 11.06 7.34 14.68 4.89 3.63 11.69 5.44 20.39 5.44zm227.59-4.35v27.19H2041.4v-21.48l79.67-96.53h-78.04v-27.19h121.54v21.48l-79.94 96.53h82.11zm165.59-44.59c0 2.36-.18 5.71-.54 10.06h-113.93c2 10.7 7.2 19.17 15.63 25.43 8.43 6.25 18.9 9.38 31.41 9.38 15.95 0 29.09-5.26 39.43-15.77l18.22 20.94c-6.52 7.8-14.77 13.69-24.74 17.67-9.97 3.99-21.21 5.98-33.72 5.98-15.95 0-30-3.17-42.15-9.52s-21.53-15.19-28.15-26.51c-6.61-11.33-9.92-24.16-9.92-38.48 0-14.14 3.22-26.87 9.65-38.2 6.44-11.33 15.37-20.17 26.79-26.51 11.42-6.35 24.29-9.52 38.61-9.52 14.14 0 26.78 3.13 37.93 9.38s19.85 15.05 26.1 26.37c6.26 11.33 9.38 24.43 9.38 39.29zm-73.41-47.85c-10.88 0-20.07 3.22-27.6 9.65-7.52 6.44-12.1 15-13.73 25.7h82.39c-1.45-10.52-5.89-19.03-13.32-25.56-7.44-6.53-16.68-9.79-27.74-9.79",
  style: {
    fill: "url(#a)",
    fillRule: "nonzero"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M1567.06 884.34c12.55 0 22.72 10.17 22.72 22.72s-10.17 22.72-22.72 22.72-22.72-10.17-22.72-22.72 10.17-22.72 22.72-22.72",
  style: {
    fill: "#e32b2b"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M583.67 762.57c124.13 8.15 222.29 111.4 222.29 237.59 0 81.87-41.32 154.07-104.23 196.93V959.68c0-7.9-6.46-14.36-14.36-14.36S673 951.79 673 959.68v254.17c-31.72 15.65-67.42 24.44-105.18 24.44-36.59 0-71.25-8.26-102.22-23V963.73c0-7.9-6.46-14.36-14.37-14.36-7.9 0-14.36 6.47-14.36 14.36v235.33c-64.57-42.59-107.19-115.77-107.19-198.91 0-127.2 99.72-231.09 225.25-237.78v254.38c0 7.9 6.46 14.37 14.36 14.37s14.37-6.46 14.37-14.37V762.56z",
  style: {
    fill: "url(#b)"
  }
}));
export { SvgOhifLogo as ReactComponent };
export default __webpack_public_path__ + "assets/images/ohif-logo.svg";